import React from "react";

export function disqualifiedExpressionWithLabeling(nodeList) {
  return nodeList.map((node, index) => {
    if (node.disqualified) {
      return (<span key={index} className="color-error">{node.text}</span>);
    } else {
      return (<span key={index}>{node.text}</span>);
    }
  });
}

export function expressionTextToNodeList(disqualifiedExpressionText) {
  // Converts a string "during_hours and {repeat} and landline" to an array of hashes of this shape:
  // [
  //   { text: "during_hours and ", disqualified: false },
  //   { text: "repeat", disqualified: true },
  //   { text: " and landline", disqualified: false }
  // ]
  const nodeList = [];
  let currentlyParsingDisqualifiedTerminal = false;
  let currentText = "";

  for (let i = 0; i < disqualifiedExpressionText.length; i++) {
    const currentChar = disqualifiedExpressionText[i];

    if (currentlyParsingDisqualifiedTerminal) {
      currentText = currentText.concat(currentChar); // Needs to be before '}' handling.
      if (currentChar === "}") {
        // Don't need to check current text length since this can only ever be reached if there was an opening brace prior
        nodeList.push({ text: currentText.replace(/\{|\}/g, ''), disqualified: true });
        currentText = "";
        currentlyParsingDisqualifiedTerminal = false;
      }
    } else {
      if (currentChar === "{") {
        if (currentText.length > 0) {
          nodeList.push({ text: currentText.replace(/\{|\}/g, ''), disqualified: false });
          currentText = "";
        }
        currentlyParsingDisqualifiedTerminal = true;
      }
      currentText = currentText.concat(currentChar); // Needs to be after '{' handling.
    }
  }

  if (currentText.length > 0) {
    nodeList.push({ text: currentText, disqualified: false });
  }

  return nodeList;
}
